var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFavouriteFillAvatarDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 60 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFavouriteFillAvatarDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,0 C11.7002365,0 0,11.475232 0,25.5 C0,39.524768 11.7002365,51 26,51 C40.2997635,51 52,39.524768 52,25.5 C52,11.475232 40.2997635,0 26,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.5%",
    y: "-10.8%",
    width: "125.0%",
    height: "125.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFavouriteFillAvatarDesktop",
    transform: "translate(4.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#10C2E1",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.4487648,22.9690189 L34.2686909,27.9602825 C33.8092925,28.4033978 33.5983386,29.0428883 33.7072938,29.6706827 L34.9299214,36.7177372 C34.9872594,37.0453948 34.9049358,37.348183 34.6927047,37.5964265 C34.473289,37.8539005 34.1579872,38 33.825766,38 C33.6441578,38 33.4703073,37.957022 33.3010759,37.8689354 L26.8971759,34.5411159 C26.3387111,34.2534865 25.6596782,34.2528288 25.1043942,34.5406084 L18.7006715,37.8686425 C18.2395156,38.1081871 17.6429936,37.9900969 17.3092787,37.5980574 C17.095687,37.3478568 17.0133983,37.0456362 17.0704756,36.7188578 L18.2927297,29.6705473 C18.4017577,29.0435584 18.1906856,28.4033767 17.7316842,27.9606441 L12.551193,22.9695635 C12.2452372,22.6748462 12.139895,22.2529619 12.2710857,21.8532493 C12.4033693,21.4511562 12.7454795,21.1661013 13.1750674,21.1045505 L20.3347807,20.0762878 C20.9639779,19.9857197 21.5098165,19.5941881 21.7928251,19.0262204 L24.9938302,12.6147673 C25.1834413,12.2346937 25.5655407,12 26.000296,12 C26.4355998,12 26.8177241,12.2346561 27.0072167,12.6144923 L30.2081007,19.0263043 C30.4907529,19.5935572 31.0359796,19.9851283 31.6649045,20.0756573 L38.8246037,21.1039181 C39.2549321,21.1658425 39.5966171,21.4505298 39.7291324,21.8533279 C39.8455525,22.208038 39.7752547,22.5807909 39.5433579,22.866192 L39.4487648,22.9690189 Z",
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavouriteFillAvatarDesktop);
export default __webpack_public_path__ + "static/media/icFavouriteFillAvatarDesktop.98a9a1dfb04c46b602b7f2979a99060d.svg";
export { ForwardRef as ReactComponent };